import React, { PureComponent } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


export default class Example extends PureComponent {
        constructor(props){
                super(props);
                this.state = {
                        data: props.data
                }
        }
        render() {
                return (
                        <ResponsiveContainer width="100%" height="100%" minHeight="330px" minWidth="500px">
                                <BarChart
                                        width={500}
                                        height={300}
                                        data={this.props.data}
                                >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="name" />
                                        <YAxis />
                                        <Tooltip />
                                        <Legend />
                                        <Bar dataKey="count" fill="#413ea0" radius={[5, 5, 0, 0]}/>
                                </BarChart>
                        </ResponsiveContainer>
                );
        }
}
